var React = require('react');

function Hurricane (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 96l24.5-74.79A16.22 16.22 0 0 0 183.1.12C80 12.42 0 101.61 0 208c0 114.9 93.1 208 208 208l-24.5 74.79a16.24 16.24 0 0 0 17.4 21.1C304 499.58 384 410.39 384 304c0-114.9-93.1-208-208-208zm16 256a96 96 0 1 1 96-96 96 96 0 0 1-96 96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M236 256a44 44 0 1 1-44-44 44 44 0 0 1 44 44z","className":"fa-primary","key":2})]);
}

Hurricane.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Hurricane;

Hurricane.default = Hurricane;
